module.exports = __webpack_public_path__ + "static/media/outfit1.dda49e09.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/outfit/outfit1.png
// module id = 269
// module chunks = 0